import { Card, CardBody, Col, Row } from "reactstrap";
import DarkBackground from "./DarkBackground";
import ExtendedBackground from "./ExtendedBackground";
import LightBackground from "./LightBackground";
import { BackgroundColorsTitle } from "../../../../constants";
import { BackgroundColorSubTitle } from "../../../../data/uiKits/HelperClasses";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";

const BackgroundColors = () => {
  return (
    <Col xs="12">
      <Card>
        <CommonCardHeader title={BackgroundColorsTitle} span={BackgroundColorSubTitle} />
        <CardBody>
          <Row className="g-3">
            <DarkBackground />
            <LightBackground />
            <ExtendedBackground />
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};
export default BackgroundColors